export const gplayCollections = [
    { code: "TOP_FREE", name: "Top Free" },
    { code: "TOP_PAID", name: "Top Paid" },
    { code: "GROSSING", name: "Top Grossing" },
];

export const gplayCategories = [
    { code: "", name: "No Category" },
    { code: "APPLICATION", name: "Application" },
    { code: "ANDROID_WEAR", name: "Android Wear" },
    { code: "ART_AND_DESIGN", name: "Art and Design" },
    { code: "AUTO_AND_VEHICLES", name: "Auto and Vehicle" },
    { code: "BEAUTY", name: "Beauty" },
    { code: "BOOKS_AND_REFERENCE", name: "Books and Reference" },
    { code: "BUSINESS", name: "Business" },
    { code: "COMICS", name: "Comics" },
    { code: "COMMUNICATION", name: "Communication" },
    { code: "DATING", name: "Dating" },
    { code: "EDUCATION", name: "Education" },
    { code: "ENTERTAINMENT", name: "Entertainment" },
    { code: "EVENTS", name: "Events" },
    { code: "FINANCE", name: "Finance" },
    { code: "FOOD_AND_DRINK", name: "Food and Drink" },
    { code: "HEALTH_AND_FITNESS", name: "Health and Fitness" },
    { code: "HOUSE_AND_HOME", name: "House and Home" },
    { code: "LIBRARIES_AND_DEMO", name: "Libraries and Demo" },
    { code: "LIFESTYLE", name: "Lifestyle" },
    { code: "MAPS_AND_NAVIGATION", name: "Maps and Navigation" },
    { code: "MEDICAL", name: "Medical" },
    { code: "MUSIC_AND_AUDIO", name: "Music and Audio" },
    { code: "NEWS_AND_MAGAZINES", name: "News and Magazines" },
    { code: "PARENTING", name: "Parenting" },
    { code: "PERSONALIZATION", name: "Personalization" },
    { code: "PHOTOGRAPHY", name: "Photography" },
    { code: "PRODUCTIVITY", name: "Productivity" },
    { code: "SHOPPING", name: "Shopping" },
    { code: "SOCIAL", name: "Social" },
    { code: "SPORTS", name: "Sports" },
    { code: "TOOLS", name: "Tools" },
    { code: "TRAVEL_AND_LOCAL", name: "Travel and Local" },
    { code: "VIDEO_PLAYERS", name: "Video Players" },
    { code: "WATCH_FACE", name: "Watch Face" },
    { code: "WEATHER", name: "Weather" },
    { code: "GAME", name: "Games" },
    { code: "GAME_ACTION", name: "Action Games" },
    { code: "GAME_ADVENTURE", name: "Adventure Games" },
    { code: "GAME_ARCADE", name: "Arcade Games" },
    { code: "GAME_BOARD", name: "Board Games" },
    { code: "GAME_CARD", name: "Card Games" },
    { code: "GAME_CASINO", name: "Casino Games" },
    { code: "GAME_CASUAL", name: "Casual Games" },
    { code: "GAME_EDUCATIONAL", name: "Educational Games" },
    { code: "GAME_MUSIC", name: "Music Games" },
    { code: "GAME_PUZZLE", name: "Puzzle Games" },
    { code: "GAME_RACING", name: "Racing Games" },
    { code: "GAME_ROLE_PLAYING", name: "Role Playing Games" },
    { code: "GAME_SIMULATION", name: "Simulation Games" },
    { code: "GAME_SPORTS", name: "Sports Games" },
    { code: "GAME_STRATEGY", name: "Strategy Games" },
    { code: "GAME_TRIVIA", name: "Trivia Games" },
    { code: "GAME_WORD", name: "Word Games" },
    { code: "FAMILY", name: "Family" },
];

export const iosCollections = [
    {
        device: "MAC",
        collections: [
            { code: "topmacapps", name: "Top Mac Apps" },
            { code: "topfreemacapps", name: " Top Free Mac Apps" },
            { code: "topgrossingmacapps", name: "Top Grossing Mac Apps" },
            { code: "toppaidmacapps", name: "Top Paid Mac Apps" },
        ],
    },
    {
        device: "IOS",
        collections: [
            { code: "newapplications", name: "New iOS Apps" },
            { code: "newfreeapplications", name: "New Free iOS Apps" },
            { code: "newpaidapplications", name: "New Paid iOS Apps" },
            { code: "topfreeapplications", name: "Top Free iOS Apps" },
            { code: "toppaidapplications", name: "Top Paid iOS Apps" },
            { code: "topgrossingapplications", name: "Top Grossing iOS Apps" },
        ],
    },
    {
        device: "IPAD",
        collections: [
            { code: "topfreeipadapplications", name: "Top Free iPad Apps" },
            { code: "toppaidipadapplications", name: "Top Paid iPad Apps" },
            { code: "topgrossingipadapplications", name: "Top Grossing iPad Apps" },
        ],
    },
];

export const iosCategories = [
    { code: "", name: "No Category", csvName: "" },
    { name: "Books", code: 6018, csvName: "BOOKS" },
    { name: "Business", code: 6000, csvName: "BUSINESS" },
    { name: "Education", code: 6017, csvName: "EDUCATION" },
    { name: "Entertainment", code: 6016, csvName: "ENTERTAINMENT" },
    { name: "Finance", code: 6015, csvName: "FINANCE" },
    { name: "Food and Drink", code: 6023, csvName: "FOOD_AND_DRINK" },
    { name: "Games", code: 6014, csvName: "GAMES" },
    { name: "Action Games", code: 7001, csvName: "GAMES_ACTION" },
    { name: "Adventure Games", code: 7002, csvName: "GAMES_ADVENTURE" },
    { name: "Arcade Games", code: 7003, csvName: "GAMES_ARCADE" },
    { name: "Board Games", code: 7004, csvName: "GAMES_BOARD" },
    { name: "Card Games", code: 7005, csvName: "GAMES_CARD" },
    { name: "Casino Games", code: 7006, csvName: "GAMES_CASINO" },
    { name: "Dice Games", code: 7007, csvName: "GAMES_DICE" },
    { name: "Educational Games", code: 7008, csvName: "GAMES_EDUCATIONAL" },
    { name: "Family Games", code: 7009, csvName: "GAMES_FAMILY" },
    { name: "Music Games", code: 7011, csvName: "GAMES_MUSIC" },
    { name: "Puzzle Games", code: 7012, csvName: "GAMES_PUZZLE" },
    { name: "Racing Games", code: 7013, csvName: "GAMES_RACING" },
    { name: "Role Playing Games", code: 7014, csvName: "GAMES_ROLE_PLAYING" },
    { name: "Simulation Games", code: 7015, csvName: "GAMES_SIMULATION" },
    { name: "Sports Games", code: 7016, csvName: "GAMES_SPORTS" },
    { name: "Strategy Games", code: 7017, csvName: "GAMES_STRATEGY" },
    { name: "Trivia Games", code: 7018, csvName: "GAMES_TRIVIA" },
    { name: "Word Games", code: 7019, csvName: "GAMES_WORD" },
    { name: "Health and Fitness", code: 6013, csvName: "HEALTH_AND_FITNESS" },
    { name: "Lifestyle", code: 6012, csvName: "LIFESTYLE" },
    { name: "Magazines and Newspapers", code: 6021, csvName: "MAGAZINES_AND_NEWSPAPERS" },
    { name: "Medical", code: 6020, csvName: "MEDICAL" },
    { name: "Music", code: 6011, csvName: "MUSIC" },
    { name: "Navigation", code: 6010, csvName: "NAVIGATION" },
    { name: "News", code: 6009, csvName: "NEWS" },
    { name: "Photo and Video", code: 6008, csvName: "PHOTO_AND_VIDEO" },
    { name: "Productivity", code: 6007, csvName: "PRODUCTIVITY" },
    { name: "Reference", code: 6006, csvName: "REFERENCE" },
    { name: "Shopping", code: 6024, csvName: "SHOPPING" },
    { name: "Social Networking", code: 6005, csvName: "SOCIAL_NETWORKING" },
    { name: "Sports", code: 6004, csvName: "SPORTS" },
    { name: "Travel", code: 6003, csvName: "TRAVEL" },
    { name: "Utilities", code: 6002, csvName: "UTILITIES" },
    { name: "Weather", code: 6001, csvName: "WEATHER" },
];

export const iosDevices = [
    { name: "Mac", code: "MAC" },
    { name: "iOS", code: "IOS" },
    { name: "iPad", code: "IPAD" },
];

// Per-collection category lists (MAC)
export const iosCategories_topmacapps = [...iosCategories].filter(
    ({ csvName }) =>
        ![
            "",
            "BOOKS",
            "BUSINESS",
            "EDUCATION",
            "ENTERTAINMENT",
            "FINANCE",
            "FOOD_AND_DRINK",
            "GAMES_CASINO",
            "GAMES_DICE",
            "GAMES_EDUCATIONAL",
            "GAMES_RACING",
            "GAMES_ROLE_PLAYING",
            "GAMES_SPORTS",
            "GAMES_TRIVIA",
            "HEALTH_AND_FITNESS",
            "LIFESTYLE",
            "MEDICAL",
            "MUSIC",
            "NEWS",
            "NAVIGATION",
            "PHOTO_AND_VIDEO",
            "PRODUCTIVITY",
            "REFERENCE",
            "SPORTS",
            "SOCIAL_NETWORKING",
            "SHOPPING",
            "UTILITIES",
            "WEATHER",
            "MAGAZINES_AND_NEWSPAPERS",
        ].includes(csvName),
);
export const iosCategories_topfreemacapps = [...iosCategories].filter(
    ({ csvName }) => !["GAMES_EDUCATIONAL", "GAMES_DICE"].includes(csvName),
);
export const iosCategories_topgrossingmacapps = [...iosCategories].filter(
    ({ csvName }) => !["", "GAMES_EDUCATIONAL", "GAMES_DICE"].includes(csvName),
);
export const iosCategories_toppaidmacapps = [...iosCategories].filter(
    ({ csvName }) => !["", "GAMES_EDUCATIONAL", "GAMES_DICE"].includes(csvName),
);

export const gplayCategories_topfree = [...gplayCategories].filter(
    ({ code }) => ["", "GAME_BOARD", "GAME_CARD", "GAME_PUZZLE"].includes(code),
)
export const gplayCategories_toppaid = [...gplayCategories].filter(
    ({ code }) => ["", "BEAUTY", "COMICS", "EVENTS", "HOUSE_AND_HOME", "PARENTING"].includes(code),
)

export const gplayCategories_topgrossing = [...gplayCategories].filter(
    ({ code }) => ["", "APPLICATION", "GAME_CARD", "GAME_CASINO"].includes(code),
)
// Per-collection category lists (IOS)
export const iosCategories_newapplications = [{ code: "", name: "No Category", csvName: "" }];
export const iosCategories_newfreeapplications = [{ code: "", name: "No Category", csvName: "" }];
export const iosCategories_newpaidapplications = [{ code: "", name: "No Category", csvName: "" }];
export const iosCategories_topfreeapplications = [...iosCategories].filter(
    ({ csvName }) => !["GAMES_EDUCATIONAL", "GAMES_DICE"].includes(csvName),
);
export const iosCategories_toppaidapplications = [...iosCategories].filter(
    ({ csvName }) => !["GAMES_EDUCATIONAL", "GAMES_DICE"].includes(csvName),
);
export const iosCategories_topgrossingapplications = [...iosCategories].filter(
    ({ csvName }) => !["GAMES_EDUCATIONAL", "GAMES_DICE"].includes(csvName),
);

// Per-collection category lists (IPAD)
export const iosCategories_topfreeipadapplications = [...iosCategories].filter(
    ({ csvName }) => !["GAMES_EDUCATIONAL", "GAMES_DICE"].includes(csvName),
);
export const iosCategories_toppaidipadapplications = [...iosCategories].filter(
    ({ csvName }) => !["GAMES_EDUCATIONAL", "GAMES_DICE"].includes(csvName),
);
export const iosCategories_topgrossingipadapplications = [...iosCategories].filter(
    ({ csvName }) => !["GAMES_EDUCATIONAL", "GAMES_DICE"].includes(csvName),
);
